/**
 * Types for Fill in the Blanks prompt form
 */

import type { UploadedDocument } from '../types';

export type { UploadedDocument };

// WHY: Align media with Agent recipe companions (gap_typing_passage / image / audio).
// No ticket on main; SSOT GEN_QUESTION_CONTRACT + agents/01_hub_fe.md.
export type FITBMediaType = 'none' | 'passage' | 'image' | 'audio';

export type FITBSourceType = 'topic' | 'document';

export interface FillInTheBlanksFormState {
    media: FITBMediaType;
    // WHY: Prefer Agent recipe key in form state so wire option is 1:1 (no Hub alias).
    num_blanks: number;
    sourceType: FITBSourceType;
    description: string;
    documents: UploadedDocument[];
}

export const MEDIA_OPTIONS: { value: FITBMediaType; label: string }[] = [
    { value: 'none', label: 'None' },
    { value: 'passage', label: 'Passage' },
    { value: 'image', label: 'Image' },
    { value: 'audio', label: 'Audio' },
];

// WHY: Mirror Agent GapQuestionTypeConfig.num_blanks (ge=1, le=15).
export const MIN_NUM_BLANKS = 1;
export const MAX_NUM_BLANKS = 15;

export const DEFAULT_FORM_STATE: FillInTheBlanksFormState = {
    media: 'none',
    num_blanks: 1,
    sourceType: 'topic',
    description: '',
    documents: [],
};

export const DOCUMENT_ACCEPT = '.pdf,.txt,.doc,.docx,.rtf';
